import { useContext } from "react";
import WeekPlannerContext from "../context/WeekPlannerContext";

export const useWeek = () => useContext(WeekPlannerContext);
